import { render, staticRenderFns } from "./ProdutividadeColaborador.vue?vue&type=template&id=f0eb9636&"
import script from "./ProdutividadeColaborador.vue?vue&type=script&lang=js&"
export * from "./ProdutividadeColaborador.vue?vue&type=script&lang=js&"
import style0 from "./ProdutividadeColaborador.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports